import { PopupTypes } from '@pascal/pascal-core';

export const specificLocalStorageKeys = { isBonusIslandNotifier: 'isBonusIslandNotifier' };

export const CurrentPopUpTypes = {
  ...PopupTypes,
  BonusIsland: 'BonusIsland',
};
